<template>
  <focus-trap :active="focusTrapActive">
    <section :class="['customizer', themeBackground, {'is-apac': regionIsApac }]" :style="themeBackgroundStyle">
      <base-spinner v-show="$store.state.utils.trayDisabled.geostates && !$store.state.utils.isDesignTransfering" classes="customizer-base-spinner"></base-spinner>
      <div
        v-show="showNewLoadingSpinner"
        class="customizer-design-modal__spinner-wrapper"
      >
        <loading-spinner
          ref="spinner"
          :show-spinner-default="true"
        ></loading-spinner>
      </div>
      <template v-if="configuration">
        <div v-if="themeVideo" :class="themeVideo">
          <video id="themeVideo" muted autoplay loop playsinline>
            <source id="webm_src" :src="`${themeVideoSrc}.webm`" type="video/webm">
            <source id="mp4_src" :src="`${themeVideoSrc}.mp4`" type="video/mp4" />
            Your browser does not support HTML5 video.
          </video>
        </div>
        <customizer-new-header
          v-if="configuration.enableCustomizerNewHeader && !queryParams.slim"
          :enable-randomize="isRandomizeEnabled && isMobile"
          :enable-undo="configuration.enableUndo"
          :enable-start-over="configuration.enableStartOver"
          :enable-share="enableShareButton"
          :enable-favorites="configuration.enableFavorites && !disableFavorites"
          :enable-transfer-design="enableTransferDesignButton"
          :enable-splash-page="enableSplashPage && (isMobile || screenOrientation === 'landscape')"
          :enable-buy-panel="configuration.enableBuyPanel"
          :enable-finish-my-design="enableFinishMyDesign"
        ></customizer-new-header>
        <!-- all inline style is test code and will be removed during customizer transition -->
        <scene-setup></scene-setup>

        <swatch-tray v-if="configuration.enableAtomicSwatchTray && !queryParams.slim">
          <template v-if="renderSwatchView" v-slot:navigation>
          <!-- eslint-disable-next-line -->
            <legacy-navigation v-if="!isFlyOutMenuEnable && !isApparelEnabled"/>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:buybutton>
            <div
              v-show="configuration.enableBuyPanel && isMobile"
              :class="['customizer-new-header__container-buy-button customizer-new-header__container-buy-button--mobile', {
                'customizer-new-header__container-buy-button__apparel-mobile': isApparelEnabled || configuration.enableFlyOutMenu
              }]"
            >
              <buy-button-label class="customizer-new-header__buy-button"></buy-button-label>
            </div>
          </template>
        </swatch-tray>
        <swatches-view v-if="!configuration.enableAtomicSwatchTray && !queryParams.slim">
          <template v-if="renderSwatchView" v-slot:navigation>
          <!-- eslint-disable-next-line -->
            <legacy-navigation v-if="!isFlyOutMenuEnable && !isApparelEnabled"/>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:buybutton>
            <div
              v-show="configuration.enableBuyPanel && isMobile"
              :class="['customizer-new-header__container-buy-button customizer-new-header__container-buy-button--mobile', {
                'customizer-new-header__container-buy-button__apparel-mobile': isApparelEnabled || configuration.enableFlyOutMenu
              }]"
            >
              <buy-button-label class="customizer-new-header__buy-button"></buy-button-label>
            </div>
          </template>
        </swatches-view>

        <embroidery v-if="isPersonalizationEnabled && configuration.enableEmbroidery && !configuration.modals.embroidery || !queryParams.slim" />
        <embroidery-modal v-if="isPersonalizationEnabled && configuration.modals.embroidery && !queryParams.slim" />
        <slot></slot>

        <patternmaker-modal v-if="configuration.vct_settings && configuration.vct_settings.pattern_maker.enabled && !configuration.modals.patternMaker || !queryParams.slim" :is-main-app="false"></patternmaker-modal>
        <pattern-maker v-if="configuration.vct_settings && configuration.vct_settings.pattern_maker.enabled && configuration.modals.patternMaker || !queryParams.slim"></pattern-maker>

        <template v-if="configuration.vct_settings && configuration.vct_settings.custom_checkerboard.enabled && !queryParams.slim">
          <customcheckerboard :is-main-app="false"></customcheckerboard>
        </template>

        <template v-if="isUGCEnabled && !queryParams.slim">
          <template v-if="configuration.enableIntroVideo">
            <intro-videos-modal v-if="configuration.modals.ugcIntroVideos" />
            <intro-videos-wrapper v-else />
          </template>
          <ugc-reposition-warning-modal v-if="configuration.modals?.ugcRepositionWarning"></ugc-reposition-warning-modal>
          <new-reposition-warning-modal v-else></new-reposition-warning-modal>
          <ugc-size-selection-modal v-if="configuration.modals?.ugcSizeSelection"></ugc-size-selection-modal>
          <new-size-selection-modal v-else></new-size-selection-modal>
          <new-ugc-modal v-if="configuration.enableNewUgcModal"></new-ugc-modal>
          <ugc-modal v-else></ugc-modal>
          <terms-condition-modal v-if="!configuration.ugc.enableNewUgcTermConditions" ></terms-condition-modal>
          <new-terms-condition-modal v-else ></new-terms-condition-modal>
          <ugc-placement-warning-modal v-if="configuration.modals?.ugcPlacementError"></ugc-placement-warning-modal>
          <new-placement-warning-modal v-else></new-placement-warning-modal>
          <ugc-uploading-image v-if="configuration.modals?.ugcUploading"></ugc-uploading-image>
          <new-upload-modal v-else></new-upload-modal>
          <AddYourImageGallery v-if="configuration?.image_library?.models_enabled?.[pdm?.sku]"></AddYourImageGallery>
          <ugc-upload-image-error-modal v-if="configuration.modals.ugcErrorImg"></ugc-upload-image-error-modal>
          <new-upload-error-modal v-else />
        </template>
        <new-modal-wrapper v-if="!queryParams.slim"
          :widthModal="'92%'"
          :heightModal="'55%'"
          ref="recipeValidationModal"
          modal-name="recipeValidationModal"
          cta-primary-button="startOverAccept"
          cta-secondary-button="reset"
          :show-close-icon="false"
          :click-to-close="false"
          @cta-action="$refs.recipeValidation.startOver()"
          @cta-secondary-action="$refs.recipeValidation.resetComponent()"
        >
          <recipe-validation-modal ref="recipeValidation"></recipe-validation-modal>
        </new-modal-wrapper>
        <new-modal-wrapper
          v-if="configuration.enableNewRecipeDeclinedModal && !queryParams.slim"
          :widthModal="'80%'"
          :maxWidthModal="500"
          modal-name="recipeDeclinedModal"
          cta-primary-button="recipeDeclinedContCustomizing"
          @cta-action="$modal.hide('recipeDeclinedModal')"
        >
          <recipe-declined-modal :product-name="this.pdm && this.pdm.product_name"></recipe-declined-modal>
        </new-modal-wrapper>
        <new-modal-wrapper v-if="!queryParams.slim"
          :widthModal="'90%'"
          :maxWidthModal="500"
          :show-close-icon="false"
          :click-to-close="false"
          modal-name="replacementModal"
          title="replacementModalTitle"
          description="replacementModalDescription"
          cta-primary-button="replacementModalCTA"
          @cta-action="$refs.shareInStore.ctaAction()" >
          <replacement-modal ref="shareInStore" ></replacement-modal>
        </new-modal-wrapper>
        <share-in-store-modal v-if="!configuration.modals.shareInStore && !queryParams.slim"></share-in-store-modal>
        <splash-page-modal v-if="enableSplashPage && !queryParams.slim"></splash-page-modal>
      </template>
      <graphics-controller v-if="!queryParams.slim" v-show="isApparelEnabled"></graphics-controller>
      <pick-your-own-color-picker v-show="activeGroup === 'yourcolors' && !$store.state.utils.isSplashModalOpen && !queryParams.slim"></pick-your-own-color-picker>
      <standard-navigation-wrapper v-if="(isApparelEnabled || isFlyOutMenuEnable) && !queryParams.slim"/>
    </section>
  </focus-trap>
</template>

<script>
import baseSpinner from '@/components/Spinner';
import buyButtonLabel from '@/components/Customizer/CustomizerHeader/BuyButtonLabel';
import customizerNewHeader from '@/components/Customizer/CustomizerNewHeader';
import sceneSetup from '@/components/Customizer/SceneSetup';
import swatchesView from '@/components/Swatches';
import SwatchTray from '@/components/organism.swatch.swatchTray.vue';
import legacyNavigation from '@/components/Customizer/LegacyNavigation';
import standardNavigationWrapper from '@/components/Customizer/StandardNavigation/StandardNavigationWrapper';
import embroidery from '@/components/Embroidery';
import embroideryModal from '@/components/organism.modal.embroidery.vue';
import patternMaker from '@/components/organism.modal.patternMaker.vue';
import patternmakerModal from '@/components/Customizer/PatternMakerModal';
import customcheckerboard from '@/components/CustomCheckerboard';
import newPlacementWarningModal from '@/components/UGC/Modals/NewPlacementWarningModal';
import newRepositionWarningModal from '@/components/UGC/Modals/NewRepositionWarningModal';
import newSizeSelectionModal from '@/components/UGC/Modals/NewSizeSelectionModal';
import ugcSizeSelectionModal from '@/components/organism.modal.ugcSizeSelection.vue';
import termsConditionModal from '@/components/UGC/Modals/TermsConditionModal';
import newTermsConditionModal from '@/components/UGC/Modals/NewTermsConditionModal';
import ugcModal from '@/components/UGC/Modals/UgcModal';
import newUgcModal from '@/components/UGC/Modals/NewUgcModal';
import newUploadErrorModal from '@/components/UGC/Modals/NewUploadErrorModal';
import newUploadModal from '@/components/UGC/Modals/NewUploadModal';
import newModalWrapper from '@/components/Modals/NewModalWrapper/NewModalWrapper';
import shareInStoreModal from '@/components/Modals/ShareInStore';
import recipeDeclinedModal from '@/components/Modals/RecipeDeclined';
import recipeValidationModal from '@/components/Modals/RecipeValidation';
import replacementModal from '@/components/Modals/Replacement';
import splashPageModal from '@/components/SplashPage';
import introVideosModal from '@/components/organism.modal.introVideos.vue';
import introVideosWrapper from '@/components/UGC/Modals/IntroVideosWrapper';
import ugcUploadImageErrorModal from '@/components/organism.modal.ugcUploadImageError.vue';
import ugcUploadingImage from '@/components/organism.modal.ugcUploadingImage.vue';
import AddYourImageGallery from '@/components/organism.modal.addYourImageGallery.vue';

import graphicsController from "@/components/GraphicsController";
import LoadingSpinner from '@/components/LoadingSpinner';
import PickYourOwnColorPicker from '@/components/PickYourOwnColorPicker';

import getScreenOrientation from '@/libs/screenOrientation';
import { themePalette, paletteHiddenFeatures } from '@/data/constants';
import ugcRepositionWarningModal from '@/components/organism.modal.ugcRepositionWarning';
import ugcPlacementWarningModal from '@/components/organism.modal.ugcPlacementWarning';
import { loadPageShowEvent } from '@/utils/pageEvents';
import { FocusTrap } from 'focus-trap-vue';

export default {
  name: "customizer",
  components: {
    buyButtonLabel,
    baseSpinner,
    customizerNewHeader,
    sceneSetup,
    swatchesView,
    SwatchTray,
    standardNavigationWrapper,
    legacyNavigation,
    embroidery,
    embroideryModal,
    FocusTrap,
    patternmakerModal,
    patternMaker,
    customcheckerboard,
    newPlacementWarningModal,
    newRepositionWarningModal,
    newSizeSelectionModal,
    ugcSizeSelectionModal,
    termsConditionModal,
    newUgcModal,
    ugcModal,
    newUploadErrorModal,
    newUploadModal,
    newModalWrapper,
    shareInStoreModal,
    newTermsConditionModal,
    recipeDeclinedModal,
    replacementModal,
    recipeValidationModal,
    splashPageModal,
    introVideosModal,
    introVideosWrapper,
    graphicsController,
    LoadingSpinner,
    PickYourOwnColorPicker,
    ugcUploadImageErrorModal,
    ugcRepositionWarningModal,
    ugcPlacementWarningModal,
    ugcUploadingImage,
    AddYourImageGallery
  },
  data() {
    return {
      activeGroup: "",
      showCustomizerSpinner: false,
      renderSwatchView: true,
      screenOrientation: null,
      focusTrapActive: false,
    }
  },
  computed: {
    configuration() {
      return this.$store.state.utils.configuration;
    },
    isFlyOutMenuEnable() {
      return this.configuration.enableFlyOutMenu;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    disableFavorites() {
      let isDisable = this.$store.state.swatches.palettes.find((item) => item.hide_wishlist === 1);
      return !!isDisable;
    },
    disableShare() {
      return !!(this.$store.getters['swatches/lockedPalettes'].length + this.$store.getters['swatches/uniqueSwatches'].length);
    },
    isUGCEnabled() {
      return this.$store.getters["utils/isUGCenabled"];
    },
    isPersonalizationEnabled() {
      return this.$store.getters["utils/isPersonalizationEnabled"];
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
    themeBackground() {
      const background_class = this.paletteTheme && this.paletteTheme.palette_features && this.paletteTheme.palette_features.background_class;
      return background_class ? themePalette.themePrefix + background_class : false;
    },
    themeVideo() {
      const video_class = this.paletteTheme && this.paletteTheme.palette_features && this.paletteTheme.palette_features.video_class;
      return video_class ? themePalette.themePrefix + video_class : false;
    },
    paletteTheme() {
      return this.$store.state.swatches.paletteTheme;
    },
    themeVideoSrc() {
      return this.paletteTheme ?
        `${this.customsAssets}/images/customizer/themes/${this.paletteTheme.tab_id}/${this.paletteTheme.palette_features.video_src}` : "";
    },
    themeBackgroundStyle() {
      if (this.themeBackground) {
        const deviceType = this.$store.getters["utils/returnScreenSize"].includes('mobile') ? 'mobile' : 'desktop';
        // the regex replaces or adds the device type (defaults to 'desktop')
        // in the file path located before the file extension
        const pattern = /^(.+?)(-desktop|-mobile)?(\..+)?$/;
        const replacement = `$1-${ deviceType }$3`
        const modifiedBgSrc = this.paletteTheme.palette_features.background_src.replace(pattern, replacement);
        const completeUrl = `${ this.customsAssets }/images/customizer/themes/${ this.paletteTheme.tab_id }/${ modifiedBgSrc }`;

        if (this.$store.getters['utils/noEsiActive'] && this.$store.getters['utils/isIframeSameOrigin']
            && this.$store.getters["utils/returnScreenSize"].includes('mobile')) {
          // need to send the inner height from parent.
          return {
            "background-image": `url(${ completeUrl })`,
            "height": window.parent.innerHeight
          };
        }

        return {
          "background-image": `url(${ completeUrl })`
        };
      }
      return false;
    },
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
    vsfActive() {
      return this.$store.getters['utils/vsfActive'];
    },
    regionIsApac() {
      return this.$store.getters['utils/regionIsApac'];
    },
    enableSplashPage() {
      return this.pdm
        && !this.configuration.splash_page?.turn_off_all_models
        && this.configuration.splash_page?.models_enabled.includes(this.pdm?.sku);
    },
    isApparelEnabled() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    enableShareButton() {
      return this.configuration.enableShareYourDesign && !this.disableShare && !this.$store.state.swatches.paletteHiddenFeatures[paletteHiddenFeatures.SHARE]
    },
    isRandomizeEnabled() {
      return this.pdm
        && !this.configuration.randomize?.turn_off_all_models
        && this.configuration.randomize?.models_enabled.includes(this.pdm?.sku);
    },
    enableTransferDesignButton() {
      return this.configuration.enableTransferDesign && !this.$store.state.swatches.paletteHiddenFeatures[paletteHiddenFeatures.TRANSFER_DESIGN]
    },
    enableFinishMyDesign() {
      return this.pdm
        && !this.configuration.finish_my_design?.turn_off_all_models
        && this.configuration.finish_my_design?.models_enabled?.includes(this.pdm?.sku);
    },
    showNewLoadingSpinner() {
      return this.$store.getters['finishMyDesign/isLoadingFinishMyDesign'];
    },
    queryParams() {
      return this.$store.state.utils.queryParams;
    }
  },
  watch: {
    ['$store.state.recipe.invalidUGCComponents'](invalidUGCComponents) {
      if (invalidUGCComponents.length > 0) this.$modal.show('recipeValidationModal');
    },
    ['$store.state.preloader.percentProgress'](value) {
      if (value >= 75) {
        this.toggleContainerFixed();
      }
    }
  },
  methods: {
    changeVisibleGroup(groupName) {
      this.activeGroup = groupName;
    },
    onWindowResized() {
      if (this.isMobile) {
        this.setViewportHeightForMobile();
      }
      this.screenOrientation = getScreenOrientation();
    },
    setViewportHeightForMobile() {
      document.documentElement.style.setProperty('--vh', `${ window.innerHeight * 0.01 }px`);
      if (this.isMobile && this.$store.getters['utils/noEsiActive'] && this.$store.getters['utils/isIframeSameOrigin']) {
        document.documentElement.style.setProperty('overflow', 'hidden');
        document.body.style.setProperty('overflow', 'visible');

      }
      if (this.isMobile && this.vsfActive) {
          document.body.style.setProperty('overflow', 'hidden');
      }

    },
    setOnbeforeunload(setEvent = false) {
      if (!this.$store.state.utils.isProduction) {
        return;
      }
      if (!setEvent && window.onbeforeunload) {
        window.onbeforeunload = null;
      } else if (setEvent && !window.onbeforeunload) {
        if (this.$recipe.isRecipeChanged()) {
          window.onbeforeunload = (event) => {
            if(this.configuration.enableExitAlert){
              const confirmationMessage = "";
              (event || window.event).returnValue = confirmationMessage;
              return confirmationMessage;
            }
          };
        }
      }
    },
    resetCustomizerScrollPosition() {
      if (!this.isMobile) return;
      if (window.scrollY > 0) {
        window.scrollTo(0,0);
      }
      this.onWindowResized();
    },
    showShareTotPurchase() {
      const onlineOnlyCookie = this.$cookies.get('medium');
      if(this.configuration.enableShareToPurchase && onlineOnlyCookie === 'onlineonly') {
        this.$store.commit("buyPanel/SET_SHOW_SHARE_TO_PURCHASE", true);
      }
    },
    toggleContainerFixed(shouldRemove = false) {
      if (this.$store.getters['utils/isMobileAndSafari']) {
        const containerEl = document
          .querySelector(this.vsfActive ? '.customs__component-container' : 'body');
        if (containerEl) {
          if (shouldRemove) {
            containerEl.classList.remove('fixed');
          } else {
            containerEl.classList.add('fixed');
            this.$eventBus.$emit('updateSwiperWidth');
          }
        }
      }
    },
    toggleSwatchesView(value = true) {
      this.renderSwatchView = value;
    },
    toggleFocusTrap(toggle) {
      this.focusTrapActive = toggle.visible;
    },
  },
  created() {
    window.addEventListener('resize', this.onWindowResized);

    this.$eventBus.$on('recalculate-customizer-screen-size', this.resetCustomizerScrollPosition);
    this.$eventBus.$on('set-onbeforeunload', this.setOnbeforeunload);
    this.$eventBus.$on("toggle-swatches-view", this.toggleSwatchesView);
    this.$eventBus.$on("changeVisibleGroup", this.changeVisibleGroup);
    this.$eventBus.$on("changeGlobalFocusState", this.toggleFocusTrap);
    if(this.vsfActive) {
      loadPageShowEvent.loadEvent();
    }
    this.setOnbeforeunload();
  },
  mounted() {
    this.onWindowResized();

    if (this.configuration) {
      this.showShareTotPurchase();
      if (this.configuration.enableExitAlert) {
        this.setOnbeforeunload(true);
      }
    }
    this.focusTrapActive=true;

    if(this.queryParams.slim) {
      this.focusTrapActive=false;
      document.getElementById("wcsEsiIncludes").classList.add("hide")
    }
  },
  beforeDestroy() {
    this.toggleContainerFixed(true);
    window.removeEventListener('resize', this.onWindowResized);

    if (this.isMobile) {
        document.documentElement.style.setProperty('overflow', '');
        document.body.style.setProperty('overflow', '');
    }

    this.$eventBus.$off('recalculate-customizer-screen-size', this.resetCustomizerScrollPosition);
    this.$eventBus.$off('set-onbeforeunload', this.setOnbeforeunload);
    this.$eventBus.$off("toggle-swatches-view", this.toggleSwatchesView);
    this.$eventBus.$off("changeVisibleGroup", this.changeVisibleGroup);
    this.$eventBus.$off("changeGlobalFocusState", this.toggleFocusTrap);
    if(this.isMainApp && this.vsfActive) { loadPageShowEvent.removeEvent(); }
  }
}
</script>
<style lang="scss">
  .customs-tools {
    @import "~@/styles/_components/Customizer/Customizer.scss";
  }

  @import "~@/styles/_components/Customizer/_partials/swatches/_popover.scss";
</style>